import { render, staticRenderFns } from "./SubCategoryView.vue?vue&type=template&id=bc20c95c&"
import script from "./SubCategoryView.vue?vue&type=script&lang=js&"
export * from "./SubCategoryView.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports